

export class Tracker {
    static _sentEvents = new Set();

    static trackFormSubmission({formName}) {
        if (this._sentEvents.has(`${formName}-form-submission`)) {
            return;
        }
        this._sentEvents.add(`signup-step-${stepName}`);
        if (window.gtag) {
            window.gtag('event', 'form_submission', {'form_name': formName});
        }
    }

    static trackSignupStep({stepName, stepIndex}) {
        if (this._sentEvents.has(`signup-step-${stepName}`)) {
            return;
        }
        this._sentEvents.add(`signup-step-${stepName}`);
        if (window.gtag) {
            window.gtag('event', 'signup_step_view', {
                'step_name': stepName,
                'step_index': stepIndex,
                debug_mode: location.hostname === "localhost" || location.hostname === "localhost:3001"
            });
        }
    }
}
